import React from 'react';
import {
  CANADA_COUNTRY,
  COUNTRY,
  CURRENCY,
  CURRENCY_CODE
} from '../../../helpers/variables';
import {FormGroup, Heading, Alert } from 'arag-ui-lib';
import { PREMIUM_SETTING_NOTES_AREA_INFO_MESSAGE, PREMIUM_SETTING_COMMENT_AREA_INFO_MESSAGE, DATE_FORMAT, ERROR, HEADING_3, INITIAL_OPTIONS } from '../../../helpers/constants';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import { getStepMessage } from '../../../helpers/premiumSettingsFunctions';

const Step5 = (props) => {
	const {
		currentStep,
		changeStoreSettings,
		limitOfIndemnity,
		notes,
		comments,
		validFrom,
		validUntil,
		selectedCoverageType,
		selectedDeductible,
		selectedEndorsement,
		coveragesOptions,
		deductiblesOptions,
		endorsementsOptions,
		premiumSettingTypeCustom,
		isApplicationPremium,
		validationMessageStep5,
		endorsements,
		stepMessages,
		isPercentagePremium,
		decimalErrors,
		checkDecimal
	} = props;
	if (currentStep !== 5)
		return null;
	const coverageTypeOptions = [
		...INITIAL_OPTIONS,
		...coveragesOptions.map(c => ({ key: c.id, label: c.name }))
	]
	const deductibleOptions = [
		...INITIAL_OPTIONS,
		...deductiblesOptions.map(c => ({ key: c.id, label: c.name }))
	]
	const endorsementOptions = [
		...INITIAL_OPTIONS,
		...endorsementsOptions.map(c => ({ key: c.id, label: c.name }))
	]
	const stepMessage = getStepMessage('5', stepMessages);
    return (
        <div>
            <Heading
                variant={HEADING_3}
                title={stepMessage}
                headingTestId={'edit-application-premium-setting-instructions'}
            />
            <FormGroup
				labelSize={"col-sm-3"}
				inputSize={"col-sm-7"}
				label={CONTENT_STRINGS.LIMIT_OF_INDEMNITY}
				variant={FORM_GROUP_VARIANTS.CURRENCY}
				errorMessage={decimalErrors?.limitOfIndemnity}
				inputProps={{
					required: true,
					onChange: ((evt) => {
						const cleaned = evt.target.value.replace(/[^0-9.]/g, '');
						if (!checkDecimal('limitOfIndemnity', cleaned)) changeStoreSettings(evt.target.name, cleaned);
					}),
					name: "limitOfIndemnity",
					value: limitOfIndemnity,
					disabledDropdown: true,
					handleOptionSelect: () => {},
					menuOptions: [
						{ sign: CURRENCY, code: CURRENCY_CODE },
					],
					selectedCurrency: {
						sign: CURRENCY,
						code: CURRENCY_CODE,
					},
                    autoComplete: 'off',
				}}
				formGroupTestId={'edit-application-premium-setting-loi-and-notes-loi'}
			/>
			<FormGroup
				labelSize={"col-sm-3"}
				inputSize={"col-sm-7"}
				label={CONTENT_STRINGS.NOTES}
				variant={FORM_GROUP_VARIANTS.TEXT_AREA}
				inputProps={{
					onChange: (evt) => changeStoreSettings(evt.target.name, evt.target.value),
					name: 'notes',
					value: notes,
					required: false
				}}
				infoText={PREMIUM_SETTING_NOTES_AREA_INFO_MESSAGE}
				formGroupInputTestId={'edit-application-premium-setting-loi-and-notes-notes'}
				formGroupLabelTestId={'edit-application-premium-setting-loi-and-notes-notes-box'}
				tooltipTestId={'edit-application-premium-setting-loi-and-notes-notes-info'}
			/>
			<FormGroup
				labelSize={"col-sm-3"}
				inputSize={"col-sm-7"}
				label={CONTENT_STRINGS.COMMENTS}
				variant={FORM_GROUP_VARIANTS.TEXT_AREA}
				inputProps={{
					onChange: (evt) => changeStoreSettings(evt.target.name, evt.target.value),
					name: 'comments',
					value: comments,
					required: false
				}}
				infoText={PREMIUM_SETTING_COMMENT_AREA_INFO_MESSAGE}
				formGroupInputTestId={'edit-application-premium-setting-loi-and-notes-comments'}
				formGroupLabelTestId={'edit-application-premium-setting-loi-and-notes-comments-box'}
				tooltipTestId={'edit-application-premium-setting-loi-and-notes-comments-info'}
			/>
            {
				COUNTRY == CANADA_COUNTRY 
				? 
					<div>
						<FormGroup
							labelSize={"col-sm-3"}
							inputSize={"col-sm-7"}
							label={CONTENT_STRINGS.COVERAGE_TYPES}
							variant={FORM_GROUP_VARIANTS.SELECT}
							inputProps={{
								onChange: (evt) => { 
									changeStoreSettings(evt.target.name, parseInt(evt.target.value));
								},
								options: coverageTypeOptions,
								value: selectedCoverageType,
								name: "selectedCoverageType",
								required: true,
							}}
							formGroupTestId={'edit-application-premium-setting-loi-and-notes-coverage-type'}
						/>
						<FormGroup
							labelSize={"col-sm-3"}
							inputSize={"col-sm-7"}
							label={CONTENT_STRINGS.DEDUCTIBLES}
							variant={FORM_GROUP_VARIANTS.SELECT}
							inputProps={{
								onChange: (evt) => { 
									changeStoreSettings(evt.target.name, parseInt(evt.target.value));
								},
								options: deductibleOptions,
								value: selectedDeductible,
								name: "selectedDeductible",
								required: true,
							}}
							formGroupTestId={'edit-application-premium-setting-loi-and-notes-deductible'}
						/>
						<FormGroup
							labelSize={"col-sm-3"}
							inputSize={"col-sm-7"}
							label={CONTENT_STRINGS.ENDORSEMENTS}
							variant={FORM_GROUP_VARIANTS.SELECT}
							inputProps={{
								onChange: (evt) => { 
									changeStoreSettings(evt.target.name, parseInt(evt.target.value));
								},
								options: endorsementOptions,
								value: selectedEndorsement,
								name: "selectedEndorsement",
								required: true,
							}}
							formGroupTestId={'edit-application-premium-setting-loi-and-notes-endorsements'}
						/>
					</div>
				: 
					<FormGroup
						labelSize={"col-sm-3"}
						inputSize={"col-sm-7"}
						label={CONTENT_STRINGS.ENDORSEMENTS}
						variant={FORM_GROUP_VARIANTS.TEXT_AREA}
						inputProps={{
							onChange: (evt) => { 
								changeStoreSettings("endorsements", evt.target.value);
							},
							value: endorsements || '',
							name: "endorsements",
							required: false,
						}}
						formGroupTestId={'edit-application-premium-setting-loi-and-notes-endorsements'}
					/>
			}
            {!isApplicationPremium && (
              	<FormGroup
					labelSize={'col-sm-3'}
					inputSize={'col-sm-7'}
					label={CONTENT_STRINGS.VALID_FROM}
					variant={FORM_GROUP_VARIANTS.DATE}
					inputProps={{
						required: true, //This is to show the asterisk
						name: 'validFrom',
						value: validFrom,
						dateInputProps: {
							required: true, //This is to check if the field is empty
							minDate: new Date(),
							dateFormat: DATE_FORMAT,
							onChange: (evt) => changeStoreSettings('validFrom', evt),
							autoComplete: 'off',
							selected: validFrom,
							placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER
						},
					}}
				/>
            )}
            {!isApplicationPremium && (premiumSettingTypeCustom || isPercentagePremium) && (
				<FormGroup
					labelSize={'col-sm-3'}
					inputSize={'col-sm-7'}
					label={CONTENT_STRINGS.VALID_UNTIL}
					variant={FORM_GROUP_VARIANTS.DATE}
					inputProps={{
						required: false,
						name: 'validUntil',
						value: validUntil,
						dateInputProps: {
							minDate:  validFrom ? validFrom : new Date(),
							dateFormat: DATE_FORMAT,
							onChange: (evt) => changeStoreSettings('validUntil', evt),
							autoComplete: 'off',
							selected: validUntil,
							placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER
						},
						infoText: CONTENT_STRINGS.CUSTOM_SETTINGS_REVERT,
					}}
				/>
            )}
            {
				validationMessageStep5
					? <Alert variant={ERROR} label={validationMessageStep5} />
					: null
            }
        </div>
    )
};

export default Step5;
